import React from "react";
import ThemeToggle from "../ThemeToggle/ThemeToggle";

const Navbar = () => {
  return (
    <nav className="navbar">
      <ul className="themes navbar-nav">
        <div className="button-group" data-button="true">
          <ThemeToggle />
        </div>
      </ul>
      <ul className="navbar-nav">
        <li className="navbar-item">
          <a href="https://twitter.com/Chippy_AI" className="navbar-link hover-button">
            <svg
              width="25"
              height="21"
              viewBox="0 0 25 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="Logo blue 1" clipPath="url(#clip0_2687_13664)">
                <g id="Logo_1_">
                  <path
                    id="white_background"
                    d="M22.3738 5.1703C22.3889 5.38905 22.3889 5.6078 22.3889 5.82856C22.3889 12.5554 17.2679 20.3134 7.90401 20.3134V20.3094C5.13788 20.3134 2.42921 19.5211 0.100586 18.0272C0.502804 18.0755 0.907038 18.0997 1.31228 18.1007C3.60462 18.1028 5.83143 17.3336 7.63486 15.9173C5.45643 15.8759 3.54615 14.4556 2.87881 12.382C3.64192 12.5292 4.42821 12.4989 5.1772 12.2943C2.8022 11.8144 1.09353 9.72776 1.09353 7.30437C1.09353 7.28219 1.09353 7.26102 1.09353 7.23985C1.80119 7.63401 2.59353 7.85276 3.40401 7.87695C1.16712 6.38199 0.477602 3.40618 1.82841 1.07957C4.41309 4.26001 8.22659 6.19348 12.3203 6.39812C11.9101 4.62997 12.4705 2.77715 13.7931 1.53421C15.8435 -0.393211 19.0683 -0.294421 20.9957 1.75497C22.1359 1.53018 23.2286 1.11183 24.2286 0.519087C23.8486 1.69751 23.0532 2.69852 21.9907 3.33461C22.9998 3.21566 23.9857 2.9455 24.9141 2.5332C24.2306 3.55739 23.3697 4.44953 22.3738 5.1703Z"
                    fill="var(--color-prompt-bg-hover, var(--color-button-bg))"
                  />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_2687_13664">
                  <rect width="25" height="20.5645" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </a>
        </li>
        <li className="navbar-item">
          <a
            href="https://chrome.google.com/webstore/detail/chippy-%E2%80%94-chatgpt-at-your/fbcdphjbmledkhefgamfaleobmegjojl"
            className="button button--active hover-button"
          >
            Add Extension
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
